import {Base} from "@/api/Base"

export class PayModeList extends Base {
    path = "payMode/list"
}